import { render } from "./VaPageNotFound.vue?vue&type=template&id=2cd2a06c"
import script from "./VaPageNotFound.vue?vue&type=script&lang=js"
export * from "./VaPageNotFound.vue?vue&type=script&lang=js"

import "./VaPageNotFound.vue?vue&type=style&index=0&id=2cd2a06c&lang=scss"
script.render = render

export default script